module.exports = __webpack_public_path__ + "img/typeother.36316ec2.png";